import { extendTailwindMerge } from 'tailwind-merge';

const twMergeExtended = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            '4xs',
            '3xs',
            '2xs',
            'md',
            'ui2-2xs',
            'ui2-xs',
            'ui2-sm',
            'ui2-base',
            'ui2-lg',
            'ui2-xl',
            'ui2-2xl',
            'ui2-3xl',
            'ui2-4xl',
          ],
        },
      ],
      rounded: ['rounded-inherit'],
      shadow: [{ shadow: ['100', '200', '300', '400', '500', 'ui2-xs', 'ui2-sm'] }],
      // @ts-expect-error
      typo: [
        'typo-large-title',
        'typo-title-1',
        'typo-title-2',
        'typo-title-3',
        'typo-headline',
        'typo-body',
        'typo-callout',
        'typo-subhead',
        'typo-footnote',
        'typo-caption-1',
        'typo-caption-2',
      ],
    },
  },
});

// not only twMerge but perhaps classNames or other helpers in the future
export const wrapClassNames = (classNames: string) => {
  return twMergeExtended(classNames);
};
